import { atom } from 'jotai';
import { createUnwrappedPitchEventsAtom, getMarkersToggleDisabled, getPitchMarkersEvents } from '@/utils/atoms/vis';
import { eventMarkersAtom } from '../queries/eventData';

export const dataLockerPitchEventsAtom = atom(async get => getPitchMarkersEvents(get, eventMarkersAtom));

export const dataLockerMarkersToggleDisabledAtom = atom(async get => getMarkersToggleDisabled(get, eventMarkersAtom));

export const dataLockerUnwrappedPitchEventsAtom = createUnwrappedPitchEventsAtom(dataLockerPitchEventsAtom);
